import { Menu } from "antd";
import { AccountIcon, AuctionIcon, BillIcon, ExitIcon, ManagmentIcon, PurchaseIcon, ReceivecashIcon } from "../../../assets/fonts/icon/icons";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../../address";
import { useLayouts } from "../layouts";
import { isEmptyObject } from "../../../tools/tools";
import { useEffect, useState } from "react";
import axios from "axios";

const MenuBar = ({ users }) => {
  const nav = useNavigate();
  const { handleExit } = useLayouts();

  return (
    <>
      {!isEmptyObject(users) && (
        <Menu
          mode="inline"
          className="side_menu_layout"
          onClick={(e) => {}}
          defaultSelectedKeys={["1"]}
          defaultOpenKeys={["menu01"]}
          items={[
            {
              key: "menu01",
              label: "مزایده ها",
              icon: <AuctionIcon />,
              onClick: () => nav(_adr.Root + _adr.Landing.Index),
            },
            {
              key: "menu02",
              label: "سفارش های من",
              icon: <BillIcon />,
              onClick: () => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.Order.Index),
            },
            {
              key: "menu03",
              label: "مدیریت اعتبار",
              icon: <ManagmentIcon />,
              onClick: () => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.Wallet.Index),
            },
            {
              key: "menu04",
              label: "تراکنش ها",
              icon: <PurchaseIcon />,
              onClick: () => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.Transactions.Index),
            },
            {
              key: "menu05",
              label: "درخواست استرداد وجه",
              icon: <ReceivecashIcon />,
              onClick: () => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.Withdraw.Index),
            },
            {
              key: "menu06",
              label: "اطلاعات حساب",
              icon: <AccountIcon />,
              onClick: () => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Review),
            },
            {
              key: "menu07",
              label: "خروج",
              icon: <ExitIcon />,
              onClick: () => handleExit(),
            },
          ]}
        />
      )}
    </>
  );
};

export default MenuBar;

export const MenuGlobal = () => {
  const nav = useNavigate();
  return (
    <>
      {" "}
      <Menu
        mode="inline"
        className="side_menu_layout"
        onClick={(e) => {}}
        defaultSelectedKeys={["1"]}
        defaultOpenKeys={["menu01"]}
        items={[
          {
            key: "menu01",
            label: "صفحه اصلی",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 1.93945L1.71973 12.2197L2.78027 13.2803L3.75 12.3105V21H10.5V14.25H13.5V21H20.25V12.3105L21.2197 13.2803L22.2803 12.2197L18.75 8.68945V5.25H17.25V7.18945L12 1.93945ZM12 4.06055L18.75 10.8105V19.5H15V12.75H9V19.5H5.25V10.8105L12 4.06055Z"
                  fill="#3D3D3D"
                />
              </svg>
            ),
            onClick: () => (window.location.href = "https://www.aptel.ir"),
          },
          {
            key: "menu02",
            label: "خرید سیم‌کارت",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M6.75 3C6.35742 3 5.95605 3.1377 5.67188 3.42188C5.3877 3.70605 5.25 4.10742 5.25 4.5V19.5C5.25 19.8926 5.3877 20.2939 5.67188 20.5781C5.95605 20.8623 6.35742 21 6.75 21H17.25C17.6426 21 18.0439 20.8623 18.3281 20.5781C18.6123 20.2939 18.75 19.8926 18.75 19.5V8.55469C18.75 8.16211 18.542 7.7373 18.3047 7.5L14.25 3.44531C14.0127 3.20801 13.5879 3 13.1953 3H6.75ZM6.75 4.5H13.1953L17.25 8.55469V19.5H6.75V4.5ZM8.25 11.25V18H15.75V11.25H8.25ZM9.75 12.75H14.25V16.5H9.75V12.75Z"
                  fill="#3D3D3D"
                />
              </svg>
            ),
            onClick: () => nav((window.location.href = "https://simcardstore.aptel.ir/html/bundle-simcard.html")),
          },
          {
            key: "menu03",
            label: "خرید بسته",
            icon: (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.75 3V7.19531L5.25 6.63281V3H3.75ZM6.75 3V6.07031L8.25 5.50781V3H6.75ZM9.75 3V4.94531L11.25 4.38281V3H9.75ZM12.75 3V4.38281L14.25 4.94531V3H12.75ZM15.75 3V5.50781L17.25 6.07031V3H15.75ZM18.75 3V6.63281L20.25 7.19531V3H18.75ZM12 6.07031L11.7422 6.16406L4.24219 8.97656L3.75 9.16406V17.6484L4.17188 17.8594L11.6719 21.4219L12 21.5625L12.3281 21.4219L19.8281 17.8594L20.25 17.6484V9.16406L19.7578 8.97656L12.2578 6.16406L12 6.07031ZM12 7.66406L17.4844 9.72656L12 12.1172L6.51562 9.72656L12 7.66406ZM5.25 10.8281L11.25 13.4531V19.5469L5.25 16.7109V10.8281ZM18.75 10.8281V16.7109L12.75 19.5469V13.4531L18.75 10.8281Z"
                  fill="#3D3D3D"
                />
              </svg>
            ),
            onClick: () => (window.location.href = "https://dcstore.aptel.ir/packages"),
          },
          {
            key: "menu04",
            label: "خرید شارژ",
            icon: (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.25 3.75V15H3V21H4.5V16.5H5.25V18.75H18.75V16.5H19.5V21H21V15H18.75V3.77344L17.7422 4.14844L15.0469 5.17969L12.3281 3.91406L12 3.75L11.6719 3.91406L8.97656 5.17969L6.28125 4.125L5.25 3.75ZM12 5.4375L14.6719 6.67969L14.9766 6.82031L15.2578 6.70312L17.25 5.92969V17.25H6.75V5.92969L8.71875 6.70312L9.02344 6.82031L9.32812 6.67969L12 5.4375ZM8.25 9.75V11.25H12.75V9.75H8.25ZM14.25 9.75V11.25H15.75V9.75H14.25ZM8.25 12.75V14.25H12.75V12.75H8.25ZM14.25 12.75V14.25H15.75V12.75H14.25Z"
                  fill="#3D3D3D"
                />
              </svg>
            ),
            onClick: () => (window.location.href = "https://dcstore.aptel.ir/directcharge"),
          },
          {
            key: "menu05",
            label: "سازمانی",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 3.75V5.25H3.75V17.25H9.75V20.25H20.25V8.25H21V6.75H14.25V5.25H15V3.75H3ZM5.25 5.25H12.75V6.75H9V8.25H9.75V15.75H5.25V5.25ZM6.75 6.75V8.25H8.25V6.75H6.75ZM11.25 8.25H12.75H14.25H18.75V18.75H11.25V8.25ZM6.75 9.75V11.25H8.25V9.75H6.75ZM12.75 9.75V11.25H14.25V9.75H12.75ZM15.75 9.75V11.25H17.25V9.75H15.75ZM6.75 12.75V14.25H8.25V12.75H6.75ZM12.75 12.75V14.25H14.25V12.75H12.75ZM15.75 12.75V14.25H17.25V12.75H15.75ZM12.75 15.75V17.25H14.25V15.75H12.75ZM15.75 15.75V17.25H17.25V15.75H15.75Z"
                  fill="#3D3D3D"
                />
              </svg>
            ),
            onClick: () => (window.location.href = "https://www.aptel.ir/organization-aptel"),
          },
          {
            key: "menu06",
            label: "خدمات",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 3V3.75V21H21V3H3ZM4.5 4.5H19.5V7.5H4.5V4.5ZM5.25 5.25V6.75H6.75V5.25H5.25ZM7.5 5.25V6.75H9V5.25H7.5ZM9.75 5.25V6.75H18.75V5.25H9.75ZM4.5 9H19.5V19.5H4.5V9ZM13.125 10.5C11.6753 10.5 10.5 11.6753 10.5 13.125C10.5 13.5592 10.615 13.9632 10.8018 14.3247C9.67976 15.4775 8.69623 16.4932 8.46973 16.7197C8.32798 16.8615 8.25 17.0498 8.25 17.25C8.25 17.4502 8.32798 17.6385 8.46973 17.7803C8.61148 17.922 8.79975 18 9 18C9.20025 18 9.38852 17.922 9.53027 17.7803C9.74477 17.5658 10.6984 16.6401 11.9224 15.4453C12.2839 15.6336 12.6893 15.75 13.125 15.75C14.5747 15.75 15.75 14.5747 15.75 13.125C15.75 12.6742 15.6251 12.2562 15.4248 11.8857L13.5 13.8105L12.4395 12.75L14.3643 10.8252C13.9938 10.6249 13.5758 10.5 13.125 10.5Z"
                  fill="#3D3D3D"
                />
              </svg>
            ),
            onClick: () => (window.location.href = "https://www.aptel.ir/online-services"),
          },
          {
            key: "menu07",
            label: "پشتیبانی",
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2.25C7.46484 2.25 3.75 5.96484 3.75 10.5V15C3.75 15.9697 4.38281 16.7959 5.25 17.1094V17.25C5.25 19.3096 6.94043 21 9 21H9.96094C10.2217 21.4482 10.6963 21.75 11.25 21.75H12.75C13.5762 21.75 14.25 21.0762 14.25 20.25C14.25 19.4238 13.5762 18.75 12.75 18.75H11.25C10.6963 18.75 10.2217 19.0518 9.96094 19.5H9C7.75781 19.5 6.75 18.4922 6.75 17.25H8.25V10.5H5.25C5.25 6.78516 8.28516 3.75 12 3.75C15.7148 3.75 18.75 6.78516 18.75 10.5H15.75V17.25H18C19.2334 17.25 20.25 16.2334 20.25 15V10.5C20.25 5.96484 16.5352 2.25 12 2.25ZM5.25 12H6.75V15.75H6C5.58398 15.75 5.25 15.416 5.25 15V12ZM17.25 12H18.75V15C18.75 15.416 18.416 15.75 18 15.75H17.25V12Z"
                  fill="#3D3D3D"
                />
              </svg>
            ),
            onClick: () => (window.location.href = "https://www.aptel.ir/WebSite/ApTel/Dealer/RegisterDealer"),
          },
          {
            key: "menu08",
            label: "خرید سیم‌کارت رند",
            icon: (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.2197 1.71973L11.7158 2.22363V2.2207L6.43945 7.5L5.93555 8.00391L6.99609 9.06445L7.5 8.56055L10.9395 12L3.21973 19.7197L4.28027 20.7803L12 13.0605L15.4395 16.5L14.9355 17.0039L15.9961 18.0645L22.2803 11.7803L21.2197 10.7197L20.7158 11.2236L12.7764 3.28418L13.2803 2.78027L12.2197 1.71973ZM11.7158 4.34473L12.9053 5.53418L9.75 8.68945L8.56055 7.5L11.7158 4.34473ZM13.9658 6.59473L17.4053 10.0342L14.25 13.1895L10.8105 9.75L13.9658 6.59473ZM18.4658 11.0947L19.6553 12.2842L16.5 15.4395L15.3105 14.25L18.4658 11.0947Z"
                  fill="#3D3D3D"
                />
              </svg>
            ),
            onClick: () => (window.location.href = "https://auction.aptel.ir"),
          },
        ]}
      />
    </>
  );
};
